import { AuthTokenType } from "@bosonprotocol/react-kit";

export const authTokenTypes = AuthTokenType;
